export const GET_VEHICLE_REQUIRED_FIELD = "profile/GET_VEHICLE_REQUIRED_FIELD";
export const SET_VEHICLE_REQUIRED_FIELD = "profile/SET_VEHICLE_REQUIRED_FIELD";
export const FETCH_VEHICLE_REQUIRED_FIELD = "profile/FETCH_VEHICLE_REQUIRED_FIELD";
export const getVehicleRequiredFiled = (data) => {
  return {
    type: GET_VEHICLE_REQUIRED_FIELD,
    payload: data,
  };
};
export const fetcVehicleRequiredFiled = (data) => {
  return {
    type: FETCH_VEHICLE_REQUIRED_FIELD,
    payload: data,
  };
};
export const setVehicleRequiredFiled = (data) => {
  return {
    type: SET_VEHICLE_REQUIRED_FIELD,
    payload: data,
  };
};
